export default __webpack_public_path__ + "static/media/Attribute_Strength.0ba84848.png";